import { Box, Stack, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import ExploreBtn from 'src/components/custom/explore-btn';
import { secondaryFont } from 'src/theme/typography';

import { styled } from '@mui/material/styles';
import { m } from 'framer-motion';
import { useResponsive } from 'src/hooks/use-responsive';
import { useLocales } from 'src/locales';
import { bgBlur } from 'src/theme/css';

const StyledTextGradient = styled(m.h1)(({ theme }) => ({
  background: '-webkit-linear-gradient(0deg, #164732, #51B949)',
  '-webkit-background-clip': 'text',
  '-webkit-text-fill-color': 'transparent',
  textTransform: 'uppercase',
  fontSize: `35px`,
  fontFamily: secondaryFont,
}));

export default function TeamOperation() {
  const { t } = useLocales();
  const theme = useTheme();

  const mdDown = useResponsive('down', 'md');

  const [selected, setSelected] = useState(null);

  const handleSelect = (value) => {
    setSelected(value);
  };

  const config = [
    {
      id: 1,
      foa: 'Mr.',
      name: 'Paul Kim',
      position: 'Founder-CEO',
      descriptions: [t('string_095'), t('string_096'), t('string_097')],
      image: '/assets/images/team/team-operation-001.png',
    },
    {
      id: 2,
      foa: 'Ms.',
      name: 'Lindsie Park',
      position: 'COO',
      descriptions: [t('string_098'), t('string_099'), t('string_100')],
      image: '/assets/images/team/team-operation-002.png',
    },
    {
      id: 3,
      foa: 'Mr.',
      name: 'Chirs Nguyen',
      position: 'CTO',
      descriptions: [t('string_101'), t('string_102'), t('string_103')],
      image: '/assets/images/team/team-operation-003.png',
    },
    {
      id: 4,
      foa: 'Mr.',
      name: 'PDucky',
      position: 'Project Manager',
      descriptions: [t('string_104'), t('string_105'), t('string_106')],
      image: '/assets/images/team/team-operation-004.png',
    },
    {
      id: 5,
      foa: 'Ms.',
      name: 'AKai Lee',
      position: 'Head of Partnership',
      descriptions: [t('string_107'), t('string_108'), t('string_109')],
      image: '/assets/images/team/team-operation-005.png',
    },
    {
      id: 6,
      foa: 'Mr.',
      name: 'Lian Lee',
      position: 'Data Analyst',
      descriptions: [t('string_110'), t('string_111'), t('string_112')],
      image: '/assets/images/team/team-operation-006.png',
    },
  ];

  const renderDesktop = !mdDown && (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent={selected ? 'space-between' : 'center'}
    >
      <Stack
        spacing={3}
        sx={{
          display: 'grid',
          gridTemplateColumns: 'auto auto auto',
          alignItems: 'center',
        }}
      >
        {config.map((x, i) => {
          const item2 = i === 1;
          const item3 = i === 2;
          const item5 = i === 4;
          const item6 = i === 5;

          return (
            <Stack
              key={i}
              position="relative"
              alignItems="flex-end"
              width={196}
              sx={{
                transition: theme.transitions.create('all'),
                ...(!!selected &&
                  (item2 || item5) && {
                    mt: '-100px',
                  }),
                ...(!!selected &&
                  (item3 || item6) && {
                    mt: '-150px',
                  }),
              }}
            >
              <Box component="img" srcSet={`${x.image} 2x`} alt="" width={158} height={184} />
              <Stack position="absolute" bottom={10} left={0}>
                <Typography fontSize={16} fontFamily={secondaryFont} fontWeight="800">
                  {x.foa}
                </Typography>
                <Typography fontSize={16} fontFamily={secondaryFont} fontWeight="800">
                  {x.name}
                </Typography>
                <Stack
                  sx={{
                    ...bgBlur({
                      opacity: 0.48,
                      color: '#FFF',
                    }),
                    width: 'fit-content',
                    p: 0.5,
                    borderRadius: '8px',
                  }}
                >
                  <Typography fontSize={14} fontWeight="800" color="#164732">
                    {x.position}
                  </Typography>
                </Stack>

                <ExploreBtn sx={{ mt: 1 }} onClick={() => handleSelect(x)} />
              </Stack>
            </Stack>
          );
        })}
      </Stack>

      {selected && (
        <Stack
          width={368}
          sx={{
            transition: theme.transitions.create('all'),
            mr: -100,
            ...(!!selected && {
              mr: 0,
            }),
          }}
        >
          <Stack position="relative" alignItems="flex-end">
            <Box component="img" srcSet={`${selected?.image} 2x`} width={295} height={344} />

            <Stack position="absolute" top="66%" left={0}>
              <Typography fontSize={25} fontFamily={secondaryFont} fontWeight="800">
                {selected?.foa}
              </Typography>
              <Typography fontSize={25} fontFamily={secondaryFont} fontWeight="800">
                {selected?.name}
              </Typography>
              <Stack
                sx={{
                  ...bgBlur({
                    opacity: 0.48,
                    color: '#FFF',
                  }),
                  width: 'fit-content',
                  p: 0.5,
                  borderRadius: '12px',
                }}
              >
                <Typography fontSize={22} fontWeight="800" color="#164732">
                  {selected?.position}
                </Typography>
              </Stack>
              {selected?.descriptions?.map((x, i) => (
                <Typography key={i} component="li">
                  {x}
                </Typography>
              ))}
            </Stack>
          </Stack>
        </Stack>
      )}
    </Stack>
  );

  const renderMobile = mdDown && (
    <Stack spacing={24} alignItems="center">
      {config.map((x, i) => (
        <Stack
          key={i}
          width={348}
          sx={{
            transition: theme.transitions.create('all'),
          }}
        >
          <Stack position="relative" alignItems="flex-end">
            <Box component="img" srcSet={`${x?.image} 2x`} width={295} height={344} />

            <Stack position="absolute" top="66%" left={0}>
              <Typography fontSize={25} fontFamily={secondaryFont} fontWeight="800" color="#000">
                {x?.foa}
              </Typography>
              <Typography fontSize={25} fontFamily={secondaryFont} fontWeight="800" color="#000">
                {x?.name}
              </Typography>
              <Stack
                sx={{
                  ...bgBlur({
                    opacity: 0.48,
                    color: '#FFF',
                  }),
                  width: 'fit-content',
                  p: 0.5,
                  borderRadius: '12px',
                }}
              >
                <Typography fontSize={22} fontWeight="800" color="#164732">
                  {x?.position}
                </Typography>
              </Stack>
              {x?.descriptions?.map((y, j) => (
                <Typography key={j} component="li">
                  {y}
                </Typography>
              ))}
            </Stack>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );

  return (
    <Stack py={12} overflowX="hidden">
      <StyledTextGradient
        sx={{
          fontSize: mdDown ? 35 : 45,
          ...(selected && {
            mb: '200px',
          }),
          textAlign: mdDown ? 'center' : 'left',
        }}
      >
        {t('string_091')}
      </StyledTextGradient>

      {renderDesktop}
      {renderMobile}
    </Stack>
  );
}
